import { PastEvent } from "../types";

export const pastEvents: PastEvent[] = [
  {
    id: "past-batik-day-2026",
    name: "Batik Day",
    date: "October 3, 2026, North and South Quad",
    event_date: "2026-10-03T15:00:00-05:00",
    location: "North and South Quad",
    description:
      "Cultural community gathering featuring a potluck, various lawn and board games, a best-dressed award, and an external partnership with Depop. Time: 3:00 PM – 7:00 PM.",
    images: [
      "/events/batik_day_2023/one.jpg",
      "/events/batik_day_2023/two.jpg",
      "/events/batik_day_2023/five.jpg",
      "/events/batik_day_2023/six.jpg",
      "/events/batik_day_2023/seven.jpg",
      "/events/batik_day_2023/eight.jpg",
      "/events/batik_day_2023/nine.jpg",
      "/events/batik_day_2023/ten.jpg",
      "/events/batik_day_2023/eleven.jpg",
    ],
    display_order: 0,
  },
  {
    id: "past-kpib-fundraiser-2026",
    name: "KPIB Fundraiser",
    date: "September 26, 2026, Anniversary Plaza",
    event_date: "2026-09-26T16:00:00-05:00",
    location: "Anniversary Plaza",
    description:
      "Public food stall event offering Pandan cookies and Pandan coffee to the community. Time: 4:00 PM – 7:00 PM.",
    images: [
      "/events/kpib_fundraising_2026/IMG_3961.jpeg",
      "/events/kpib_fundraising_2026/IMG_3962.jpeg",
      "/events/kpib_fundraising_2026/IMG_3963.jpeg",
      "/events/kpib_fundraising_2026/IMG_3964.jpeg",
      "/events/kpib_fundraising_2026/IMG_3965.jpeg",
      "/events/kpib_fundraising_2026/IMG_3966.jpeg",
      "/events/kpib_fundraising_2026/IMG_3967.jpeg",
      "/events/kpib_fundraising_2026/IMG_3968.jpeg",
      "/events/kpib_fundraising_2026/IMG_3969.jpeg",
      "/events/kpib_fundraising_2026/IMG_3970.jpeg",
      "/events/kpib_fundraising_2026/IMG_3971.jpeg",
      "/events/kpib_fundraising_2026/IMG_3972.jpeg",
      "/events/kpib_fundraising_2026/IMG_3973.jpeg",
      "/events/kpib_fundraising_2026/IMG_3974.jpeg",
      "/events/kpib_fundraising_2026/IMG_3975.jpeg",
      "/events/kpib_fundraising_2026/IMG_3976.jpeg",
      "/events/kpib_fundraising_2026/IMG_3977.jpeg",
      "/events/kpib_fundraising_2026/IMG_3978.jpeg",
      "/events/kpib_fundraising_2026/IMG_3981.jpeg",
      "/events/kpib_fundraising_2026/IMG_3982.jpeg",
      "/events/kpib_fundraising_2026/IMG_3983.jpeg",
      "/events/kpib_fundraising_2026/IMG_3984.jpeg",
      "/events/kpib_fundraising_2026/IMG_3985.jpeg",
      "/events/kpib_fundraising_2026/IMG_3986.jpeg",
      "/events/kpib_fundraising_2026/IMG_3987.jpeg",
      "/events/kpib_fundraising_2026/IMG_3988.jpeg",
      "/events/kpib_fundraising_2026/IMG_3989.jpeg",
      "/events/kpib_fundraising_2026/IMG_3990.jpeg",
      "/events/kpib_fundraising_2026/IMG_3991.jpeg",
      "/events/kpib_fundraising_2026/IMG_3992.jpeg",
      "/events/kpib_fundraising_2026/IMG_3993.jpeg",
      "/events/kpib_fundraising_2026/IMG_3994.jpeg",
      "/events/kpib_fundraising_2026/IMG_3995.jpeg",
      "/events/kpib_fundraising_2026/IMG_3996.jpeg",
      "/events/kpib_fundraising_2026/IMG_3997.jpeg",
      "/events/kpib_fundraising_2026/IMG_3998.jpeg",
      "/events/kpib_fundraising_2026/IMG_3999.jpeg",
      "/events/kpib_fundraising_2026/IMG_4000.jpeg",
      "/events/kpib_fundraising_2026/IMG_4001.jpeg",
      "/events/kpib_fundraising_2026/IMG_4002.jpeg",
      "/events/kpib_fundraising_2026/IMG_4003.jpeg",
      "/events/kpib_fundraising_2026/IMG_4004.jpeg",
      "/events/kpib_fundraising_2026/IMG_4005.jpeg",
      "/events/kpib_fundraising_2026/IMG_4006.jpeg",
      "/events/kpib_fundraising_2026/IMG_4007.jpeg",
      "/events/kpib_fundraising_2026/IMG_4008.jpeg",
      "/events/kpib_fundraising_2026/IMG_4009.jpeg",
      "/events/kpib_fundraising_2026/IMG_4010.jpeg",
      "/events/kpib_fundraising_2026/IMG_4011.jpeg",
      "/events/kpib_fundraising_2026/IMG_4012.jpeg",
      "/events/kpib_fundraising_2026/IMG_4013.jpeg",
      "/events/kpib_fundraising_2026/IMG_4014.jpeg",
      "/events/kpib_fundraising_2026/IMG_4015.jpeg",
      "/events/kpib_fundraising_2026/IMG_4016.jpeg",
      "/events/kpib_fundraising_2026/IMG_4017.jpeg",
      "/events/kpib_fundraising_2026/IMG_4018.jpeg",
      "/events/kpib_fundraising_2026/IMG_4019.jpeg",
      "/events/kpib_fundraising_2026/IMG_4020.jpeg",
      "/events/kpib_fundraising_2026/IMG_4021.jpeg",
      "/events/kpib_fundraising_2026/IMG_4022.jpeg",
      "/events/kpib_fundraising_2026/IMG_4023.jpeg",
      "/events/kpib_fundraising_2026/IMG_4025.jpeg",
      "/events/kpib_fundraising_2026/IMG_4026.jpeg",
      "/events/kpib_fundraising_2026/IMG_4027.jpeg",
      "/events/kpib_fundraising_2026/IMG_4028.jpeg",
      "/events/kpib_fundraising_2026/IMG_4029.jpeg",
      "/events/kpib_fundraising_2026/IMG_4030.jpeg",
      "/events/kpib_fundraising_2026/IMG_4031.jpeg",
    ],
    display_order: 1,
  },
  {
    id: "past-meet-greet-2026",
    name: "Online Meet & Greet",
    date: "June 27, 2026, Online",
    event_date: "2026-06-27T08:00:00-05:00",
    location: "Online",
    description:
      "Pre-arrival orientation session covering visa documentation, class registration processes, packing guides, and commuting options around the campus. Time: 8:00 AM CST.",
    images: [
      "/events/upcoming/meetgreet.png",
      "/events/welcoming_event_2024/one.png",
      "/events/welcoming_event_2024/two.png",
      "/events/welcoming_event_2024/three.png",
      "/events/welcoming_event_2024/four.png",
      "/events/welcoming_event_2024/five.png",
      "/events/welcoming_event_2024/six.png",
      "/events/welcoming_event_2024/seven.png",
      "/events/welcoming_event_2024/eight.png",
      "/events/welcoming_event_2024/nine.png",
      "/events/welcoming_event_2024/ten.png",
    ],
    display_order: 2,
  },
  {
    id: "past-welcoming-2024",
    name: "Welcoming Event 2024 - Mingle & Connect",
    date: "August 31, 2024, Scotts Park",
    event_date: "2024-08-31T14:00:00-05:00",
    location: "Scotts Park",
    description:
      "Annual welcoming event welcoming incoming and returning Indonesian students to UIUC.",
    images: [
      "/events/welcoming_event_2024/one.png",
      "/events/welcoming_event_2024/two.png",
      "/events/welcoming_event_2024/three.png",
      "/events/welcoming_event_2024/four.png",
      "/events/welcoming_event_2024/five.png",
      "/events/welcoming_event_2024/six.png",
      "/events/welcoming_event_2024/seven.png",
      "/events/welcoming_event_2024/eight.png",
      "/events/welcoming_event_2024/nine.png",
      "/events/welcoming_event_2024/ten.png",
    ],
    display_order: 3,
  },
  {
    id: "past-buka-bersama-2024",
    name: "Buka Bersama Permias UIUC X Komunitas Pengajian Urbana-Champaign",
    date: "March 23, 2024, Orchard Downs Community Center",
    event_date: "2024-03-23T17:30:00-05:00",
    location: "Orchard Downs Community Center",
    description:
      "Ramadan iftar gathering bringing together students and the broader Urbana-Champaign community.",
    images: [
      "/events/buka_bersama_2024/one.jpg",
      "/events/buka_bersama_2024/five.jpg",
      "/events/buka_bersama_2024/seven.jpg",
      "/events/buka_bersama_2024/two.jpg",
      "/events/buka_bersama_2024/six.jpg",
      "/events/buka_bersama_2024/eight.jpg",
      "/events/buka_bersama_2024/nine.jpg",
      "/events/buka_bersama_2024/ten.jpg",
      "/events/buka_bersama_2024/eleven.jpg",
    ],
    display_order: 4,
  },
  {
    id: "past-pasmal-2023",
    name: "Pasar Malam Permias UIUC",
    date: "November 11, 2023, University YMCA",
    event_date: "2023-11-11T17:00:00-05:00",
    location: "University YMCA",
    description:
      "Flagship Indonesian night market featuring authentic cuisine, cultural performances, and games.",
    images: [
      "/events/pasmal_2023/three.jpg",
      "/events/pasmal_2023/one.jpg",
      "/events/pasmal_2023/two.jpg",
      "/events/pasmal_2023/four.jpg",
      "/events/pasmal_2023/five.jpg",
      "/events/pasmal_2023/six.jpg",
      "/events/pasmal_2023/seven.jpg",
      "/events/pasmal_2023/eight.jpg",
    ],
    display_order: 5,
  },
  {
    id: "past-pumpkin-potluck-2023",
    name: "Pumpkin Potluck",
    date: "October 28, 2023, Hub on Campus",
    event_date: "2023-10-28T18:00:00-05:00",
    location: "Hub on Campus",
    description: "Fall semester potluck and social bonding gathering.",
    images: [
      "/events/pumpkin_potluck_2023/two.jpg",
      "/events/pumpkin_potluck_2023/one.jpg",
      "/events/pumpkin_potluck_2023/three.jpg",
      "/events/pumpkin_potluck_2023/four.jpg",
      "/events/pumpkin_potluck_2023/five.jpg",
      "/events/pumpkin_potluck_2023/six.jpg",
      "/events/pumpkin_potluck_2023/seven.jpg",
      "/events/pumpkin_potluck_2023/eight.jpg",
      "/events/pumpkin_potluck_2023/nine.jpg",
      "/events/pumpkin_potluck_2023/ten.jpg",
      "/events/pumpkin_potluck_2023/twelve.jpg",
      "/events/pumpkin_potluck_2023/threeee.jpg",
      "/events/pumpkin_potluck_2023/fourteen.jpg",
    ],
    display_order: 6,
  },
];
